export default Object.freeze({
  CURRENT_LANG_KEY: 'CURRENT_LANG_KEY',
  EN_TRANSLATE: 'en-translate',
  ES_TRANSLATE: 'es-translate',
});
